export default "__VITE_ASSET__DshYRAHW__"